'use client'

import { RootState } from 'features/store'
import { useRouter, usePathname } from 'next/navigation'
import React, { useEffect, ReactElement } from 'react'
import { useSelector } from 'react-redux'
import { isTokenExpired } from './utils'

const PublicWrapper: React.FC<{ children: ReactElement }> = ({ children }) => {
  const router = useRouter()
  const pathname = usePathname()

  // const { jwt_token } = useSelector(
  //   (state: RootState) => state.culineerAuth
  // )
  // if (jwt_token && !isTokenExpired(jwt_token)) {
  //       return
  //     }
      
  return children
}

export default PublicWrapper 